import { render, staticRenderFns } from "./FormMaintenanceProcessSingle.vue?vue&type=template&id=2efffb28&scoped=true"
import script from "./FormMaintenanceProcessSingle.vue?vue&type=script&lang=js"
export * from "./FormMaintenanceProcessSingle.vue?vue&type=script&lang=js"
import style0 from "./FormMaintenanceProcessSingle.vue?vue&type=style&index=0&id=2efffb28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efffb28",
  null
  
)

export default component.exports